module.exports = __webpack_public_path__ + "img/icon-property-floor.7d0b7aeb.svg";